module.exports = __webpack_public_path__ + "static/media/coolRoom.ce3e84f4.svg";